<template>
   <div v-click-outside="outsideClick">
    <div id="offcanvas-overlay" uk-offcanvas="overlay: true; container: true">
        <div class="uk-offcanvas-bar" id="filters-container">
          <div>
            <div class="filters-heading uk-text-center">
              <span class="filters-heading-text">{{$t('general.sortingAndFilters')}}</span>
            </div>
          </div>
            <MobileFilterMenu v-if="!selectedFilter" :filters="filters" :sortBy="sorting" @onSelection="filterSelected" @close="setMobileFiltersVisibility"></MobileFilterMenu>
            <Options v-else :filts="selectedFilter" @done="onOptionsClose"></Options>
        </div>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapGetters, mapActions} from 'vuex'
import MobileFilterMenu from './mobile-filter-menu'
import Options from './options'
import uikit from 'uikit'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Mobile',
  components: {
    MobileFilterMenu,
    Options
  },
  data () {
    return {
      selectedFilter: null,
      XClickCoordinate: 0
    }
  },
  props: ['filters', 'sorting'],
  computed: {
    ...mapGetters(['mobileFiltersVisibility'])
  },
  methods: {
    ...mapMutations(['updateFilters']),
    ...mapActions(['setMobileFiltersVisibility']),
    filterSelected (filter) {
      this.selectedFilter = filter
    },
    onOptionsClose (filter) {
      this.selectedFilter = null
    },
    showOverlay() {
      uikit.offcanvas('#offcanvas-overlay').show()
    },
    hideOverlay() {
      uikit.offcanvas('#offcanvas-overlay').hide()
    },
    outsideClick() {
      // using a timeout to ensure the XCoordinate is set before code execution
      setTimeout(() => {
        try {
          let container = document.getElementById('filters-container').getBoundingClientRect()
          let width = container.width
          if (width > 0) {
            if (this.XClickCoordinate > width) {
              this.setMobileFiltersVisibility()
            }
          }
        } catch (err) {}
      }, 200)
    },
    setXClickCoordinate (e) {
      this.XClickCoordinate = e.pageX
    }
  },
  watch: {
    mobileFiltersVisibility(visible) {
      if (visible) {
        this.showOverlay()
      } else {
        this.hideOverlay()
      }
    }
  },
  created() {
    window.addEventListener('click', this.setXClickCoordinate)
  },
  destroyed() {
    window.removeEventListener('click', this.setXClickCoordinate)
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../../../src/styles/colours';

  .uk-offcanvas-close {
    position: inherit
  }

  .uk-offcanvas-bar {
    max-width: 400px;
    width: 100vw;
    background-color: $app-background;
    padding: 0;
  }
  .filters-heading {
    background-color: white;
    height: 48px;
    line-height: 48px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  }
  .filters-heading-text {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    color: $content-text;
    vertical-align: middle;
    line-height: normal;
  }

</style>
